import { ShimmerElementType, Shimmer } from '@fluentui/react/lib/Shimmer';
import React from 'react';

import styles from './AppHostLoadingState.scss';

export default function AppHostLoadingState(): JSX.Element {
    const shimmerElements = [
        { type: ShimmerElementType.circle, height: 48 },
        { type: ShimmerElementType.gap, width: 32 },
        { type: ShimmerElementType.circle, height: 48 },
        { type: ShimmerElementType.gap, width: 32 },
        { type: ShimmerElementType.circle, height: 48 },
    ];

    return (
        <Shimmer
            className={styles.shimmerContainer}
            shimmerElements={shimmerElements}
            width={208}
        />
    );
}
